import { render, staticRenderFns } from "./BodyguardServicesList.vue?vue&type=template&id=2888bab4"
import script from "./BodyguardServicesList.vue?vue&type=script&lang=js"
export * from "./BodyguardServicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports